module.exports = __webpack_public_path__ + "buyXgetY.svg?18640b3328598561f760d65949db519c";